// extracted by mini-css-extract-plugin
module.exports = {"add-task-wrapper":"tasks_tab__add-task-wrapper___1hCrx","addTaskWrapper":"tasks_tab__add-task-wrapper___1hCrx"};